<template>
  <div class="layout">
    <!-- header 头部 -->
    <header-nav />
    <!-- 通栏提示 -->
    <!-- <full-tips /> -->
    <!-- 中间部分 -->
    <div class="section clearfix">
      <!-- 左侧导航 -->
      <menu-nav />
      <span class="border" />
      <!-- 右侧为内容展示区域 **** -->
      <div
        ref="sectionMain"
        class="right scroll_bar_beautify_ff"
      >
        <div class="inner">
          <router-view />
        </div>
      </div>
    </div>
    <!-- footer 尾部 -->
    <div class="footer">
      Copyright © 2008～2021 {{ $t('message["1089"]') }}
    </div>
    <change-role-tip
      ref="chageRoleTipDia"
      :rolename="rolename"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import HeaderNav from './Header'
// import FullTips from './FullTips'
import MenuNav from './Menu'
import ChangeRoleTip from './ChangeRoleTip'

export default {
  components: {
    HeaderNav,
    // FullTips,
    MenuNav,
    ChangeRoleTip
  },
  // props: {
  //   pid: {
  //     type: String,
  //     required: true
  //   }
  // },
  data () {
    return {}
  },
  computed: {
    ...mapState('project', ['project', 'isNeedCost']),
    pid () {
      return this.$store.state.pid || this.$route.params.pid
    },
    rolename () {
      return this.$store.state.baseinfo.rolename
    }
  },
  watch: {
    pid (pid) {
      this.init()
    },
    isNeedCost: {
      handler (val) {
        if (val) {
          const month = new Date().getMonth() !== 0 ? new Date().getMonth() : 12
          const that = this
          if (this.$route.name !== 'CostMaintainDetail' && this.$route.name !== 'CostMaintain') {
            this.$confirm({
              title: <div>{month}{this.$t('message["1533"]')}</div>,
              closable: false,
              width: 425,
              centered: true,
              iconType: 'exclamation-circle',
              okText: this.$t('message["903"]'),
              cancelText: this.$t('message["1005"]'),
              onOk () {
                that.$router.push({
                  name: 'CostMaintain'
                })
              },
              onCancel () {
                that.cacelCostDialog()
              }
            })
          }
        }
      },
      immediate: true
    },
    rolename (val) {
      if (val) {
        this.$refs.chageRoleTipDia.changeLimitDialog(true)
      }
    }
  },
  async beforeDestroy () {
    // await this.setPid('')
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    ...mapActions('project', ['setPid', 'fetchDatas']),
    ...mapActions('costMaintain/costIndexData', ['cacelCostDialog']),
    async init () {
      await this.setPid(this.pid)
      const chain = await this.fetchDatas()
      chain
        .params({
          id: this.pid
        })
        .onSuccess(raw => {
          if (this.rolename) {
            this.$refs.chageRoleTipDia.changeLimitDialog(true)
          }
          const { is_project_close: isProClose } = this.$store.state.baseinfo
          // isProClose=1 项目关闭
          if (isProClose) {
            this.$message.destroy()
            this.$router.push({
              path: `/project/${this.pid}/404`,
              // name: 'Project404',
              params: {
                pid: this.pid
              }
            })
          }
        })
        .fetch()
    }
    /* setRightHeight () {
      this.$nextTick(() => {
        if (!this.$refs.sectionMain) return

        this.$refs.sectionMain.style.minHeight = this.$refs.sectionMain.parentNode.offsetHeight + 'px'
      })
    } */
  }
}
</script>
<style lang="scss">
@import '../../assets/css/pc.scss';
</style>
<style lang="scss" scoped>
.layout {
  overflow: hidden;
  background-color: #f5f6f7;
  .section {
    position: relative;
    // overflow: hidden;
    max-width: 1280px;
    margin: 16px auto 0;
    background-color: #fff;
    border: solid 1px $gray4;
    border-radius: 4px;

    .border {
      position: absolute;
      left: 159px;
      top: 0;
      z-index: 999;
      width: 1px;
      height: 100%;
      background-color: $gray4;
    }
    .right {
      float: left;
      width: calc(100% - 160px);
      min-height: calc(100vh - 116px);
      padding: 0 40px;
      // border-left: solid 1px $gray4;
    }
  }

  .footer {
    height: 44px;
    line-height: 44px;
    text-align: center;
    color: $gray3;
  }
}
@media screen and (max-width: 1200px) {
  .layout .section .right {
    .inner {
      width: 966px;
    }
    overflow-x: auto;
    overflow-y: hidden;
  }
  /* .layout .section {
    width: 1200px;
    overflow: auto;
  } */
}
</style>
